var render, staticRenderFns
import script from "./SidebarItems.vue?vue&type=script&lang=js&"
export * from "./SidebarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70038e78')) {
      api.createRecord('70038e78', component.options)
    } else {
      api.reload('70038e78', component.options)
    }
    
  }
}
component.options.__file = "src/containers/SidebarItems.vue"
export default component.exports